import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import('@/assets/scss/pure.css')
import('@/assets/scss/main.css')

Vue.config.productionTip = false

// global register 测试


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
